import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nuovo ordine {{method}}!',
        scheduled: 'Ordine {{method}} programmato!',
      },
      labels: {
        today: 'oggi',
        time_remaining_to_accept: 'rimanenti per accettare',
      },
      time_tag: {
        asap: '🕓 Ritiro tra {{time}}',
        scheduled: '🕓 Ritiro {{day}} alle {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Stima ritiro approssimativa: {{time}}',
        scheduled: '🕓 Stima ritiro approssimativa: {{day}} alle {{time}}',
      },
      buttons: {
        confirm_order: 'Conferma ordine',
        cancel_order: 'Annulla ordine',
      },
      feedback: {
        rough_estimate_warning:
          'Questa è solo una stima approssimativa. Riceverai il tempo di preparazione effettivo una volta assegnato un autista e confermata la consegna. A quel punto, lo scontrino verrà stampato automaticamente.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tempo di preparazione',
      labels: {
        today: 'Oggi',
        order_time: {
          delivery: {
            asap: 'Consegna tra',
            scheduled: 'Consegna il',
          },
          other: {
            asap: 'Ritiro tra',
            scheduled: 'Ritiro il',
          },
        },
        can_you_make_it: 'Riesci a farcela?',
        we_also_send_this_update_to_the_customer: 'Inviamo questo aggiornamento anche al cliente',
      },
      buttons: {
        yes_lets_go: 'Sì, andiamo!',
        no_change_time: 'No, cambia orario',
        confirm: 'Conferma',
      },
      toasts: {
        order_confirmed: {
          title: 'Ordine #{{number}} confermato',
          body: 'Non preparare ancora! Ti avviseremo quando verrà assegnato un autista.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          "Purtroppo la consegna deve essere annullata perché l'autista non è disponibile. Clicca sui tre puntini in alto a destra per annullare l'ordine e rimborsare il cliente.",
        [BackendErrorCode.DeliveryProviderException]:
          "Purtroppo la consegna deve essere annullata perché l'autista non è disponibile. Clicca sui tre puntini in alto a destra per annullare l'ordine e rimborsare il cliente.",
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Ordine accettato, ma nessun corriere è ancora prenotato. Continuiamo a cercare per 15 minuti e ti avviseremo se non ne troviamo nessuno.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Qualcosa è andato storto, riprova',
  },
};
